import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SearchApi } from '../../../api/search-api';
import { InputConverter } from '../../../inputConverter';
import { AoiService } from '../../../services/aoi.service';
import { BaseComponent } from '../../base.component';
import { AssetConfigurationArrayConverter } from './asset-search.config';
var AssetSearchComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AssetSearchComponent, _super);
    function AssetSearchComponent(_vcr, aoiService, searchApi) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.aoiService = aoiService;
        _this.searchApi = searchApi;
        _this.searchText = '';
        _this.searchUpdated = new Subject();
        _this.propertiesArray = [];
        _this.showResults = false;
        _this.idCount = null;
        _this.activate = function () {
            if (_this.isActive) {
                return;
            }
            var debounceTimer = 500;
            _this.searchUpdated
                .pipe(debounceTime(debounceTimer), distinctUntilChanged())
                .subscribe(function (searchText) {
                var validSearch = true;
                var endChar = searchText.substr(-1);
                if (endChar === ' ' || endChar === ',') {
                    validSearch = false;
                }
                if (searchText.length !== 0 && validSearch) {
                    _this.createQuery(searchText);
                }
                else if (searchText.length === 0) {
                    _this.clearResults();
                }
            });
            _this.isActive = true;
        };
        _this.reset = function () {
            _this.searchText = '';
            _this.searchCriteria = null;
            _this.clearResults();
        };
        _this.addResultToMap = function () {
            _this.aoiService.setSearchCriterias([_this.searchCriteria]);
        };
        return _this;
    }
    Object.defineProperty(AssetSearchComponent.prototype, "properties", {
        get: function () {
            return this._properties;
        },
        set: function (value) {
            var _this = this;
            this._properties = value;
            this.properties.split(',').forEach(function (propName) {
                var e_1, _a;
                try {
                    for (var _b = tslib_1.__values(_this.config), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var prop = _c.value;
                        if (propName === prop.propName) {
                            _this.propertiesArray.push(prop);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    AssetSearchComponent.prototype.createQuery = function (searchText) {
        var e_2, _a;
        var queryString = '';
        try {
            for (var _b = tslib_1.__values(this.propertiesArray), _c = _b.next(); !_c.done; _c = _b.next()) {
                var prop = _c.value;
                if (prop.idType !== '$intId' || this.hasAllIntValues()) {
                    queryString += "\n                " + prop.propName + ": layers(id: " + prop.layerId + ") {\n                    data(\n                        fieldNames: [\"" + prop.columnName + "\"], \n                        query: {\n                            field: \"" + prop.columnName + "\", \n                            operator: \"IN\",\n                            value:  $stringIds\n                        } \n                    )\n                }\n            ";
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.getResults(queryString, searchText);
    };
    AssetSearchComponent.prototype.getResults = function (queryString, stringIds) {
        var _this = this;
        this.searchApi.getAssetIds(queryString, stringIds).then(function (results) {
            if (results) {
                _this.assignDataToProperties(results);
            }
        });
    };
    AssetSearchComponent.prototype.assignDataToProperties = function (results) {
        var e_3, _a, e_4, _b;
        this.clearResults();
        try {
            for (var _c = tslib_1.__values(this.propertiesArray), _d = _c.next(); !_d.done; _d = _c.next()) {
                var prop = _d.value;
                if (results[prop.propName] && results[prop.propName].length > 0) {
                    try {
                        for (var _e = tslib_1.__values(results[prop.propName]), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var x = _f.value;
                            prop.data = tslib_1.__spread(new Set(prop.data.concat(x.data.flat())));
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        this.showResults = true;
    };
    AssetSearchComponent.prototype.clearResults = function () {
        var e_5, _a;
        try {
            for (var _b = tslib_1.__values(this.propertiesArray), _c = _b.next(); !_c.done; _c = _b.next()) {
                var prop = _c.value;
                prop.data = [];
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        this.showResults = false;
    };
    AssetSearchComponent.prototype.selectResults = function (result) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (result.data.length === 0) {
                    return [2 /*return*/];
                }
                this.searchCriteria = {
                    type: 'assetId',
                    title: result.displayName + ": " + result.data[0],
                    layerId: result.layerId,
                    columnName: result.columnName,
                    data: String(result.data)
                };
                return [2 /*return*/];
            });
        });
    };
    AssetSearchComponent.prototype.hasAllIntValues = function () {
        var values = this.searchText.split(',').map(function (x) { return x.trim(); });
        return values.filter(function (x) { return !isNaN(parseInt(x, 10)) && isFinite(x); }).length === values.length;
    };
    tslib_1.__decorate([
        InputConverter(AssetConfigurationArrayConverter),
        tslib_1.__metadata("design:type", Array)
    ], AssetSearchComponent.prototype, "config", void 0);
    return AssetSearchComponent;
}(BaseComponent));
export { AssetSearchComponent };
